import React, { useEffect, useState } from "react";

const CircularTimer = ({
  createdAt,
  pickupTime,
  width = 70,
  height = 70,
  strokeWidth = 5,
}) => {
  const [timeLeft, setTimeLeft] = useState(0);
  const [percentage, setPercentage] = useState(100);
  const [expired, setExpired] = useState(false);

  const radius = (Math.min(width, height) - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;

  useEffect(() => {
    const startTime = new Date(createdAt).getTime();
    const endTime = new Date(pickupTime).getTime();
    const totalTime = endTime - startTime;

    const interval = setInterval(() => {
      const now = Date.now();
      const remaining = endTime - now;

      if (remaining <= 0) {
        clearInterval(interval);
        setTimeLeft(0);
        setPercentage(0);
        setExpired(true);
        return;
      }

      setTimeLeft(remaining);
      setPercentage((remaining / totalTime) * 100); // start full, decrease
      setExpired(false);
    }, 1000);

    return () => clearInterval(interval);
  }, [createdAt, pickupTime]);

  const minutes = Math.floor(timeLeft / 60000);
  const seconds = Math.floor((timeLeft % 60000) / 1000);

  return (
    <div
      style={{
        width,
        height,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg width={width} height={height}>
        {/* Background circle */}
        <circle
          r={radius}
          cx={width / 2}
          cy={height / 2}
          stroke={expired ? "#FF4D4F" : "#e6e6e6"}
          fill="transparent"
          strokeWidth={strokeWidth}
        />
        {/* Foreground circle */}
        <circle
          r={radius}
          cx={width / 2}
          cy={height / 2}
          stroke={expired ? "#FF4D4F" : "#00B177"}
          fill="transparent"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={circumference - (percentage / 100) * circumference}
          strokeLinecap="round"
          transform={`rotate(-90 ${width / 2} ${height / 2})`}
        />
        {/* Timer text */}
        <text
          x="50%"
          y="50%"
          dominantBaseline="middle"
          textAnchor="middle"
          fontSize={Math.min(width, height) * 0.2}
          fill={expired ? "#FF4D4F" : "#384F6F"}
        >
          {expired
            ? "Expired"
            : `${minutes.toString().padStart(2, "0")}:${seconds
                .toString()
                .padStart(2, "0")}`}
        </text>
      </svg>
    </div>
  );
};

export default CircularTimer;
